import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../api/axiosInstance";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded';
import EditModal from "../../../components/editModal/editModal";
import useEntity from "../../../api/useEntity";
import moment from "moment/moment";
import "./team.scss";

const Team = () => {
    const [team, setTeam] = useState([]);
    const [archivedTeam, setArchivedTeam] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showArchive, setShowArchive] = useState(false);
    const [archiveLoaded, setArchiveLoaded] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const resTeam = await axiosInstance.get("data/team?archived=false");
            const resCategories = await axiosInstance.get("forms/categories?layer=2");

            setTeam(resTeam.data);
            setCategories(resCategories.data)
        } catch (err) {
            console.error(err);
        }
    }, []);

    const toggleArchive = async () => {
        const nextState = !showArchive;

        setShowArchive(nextState);

        // Nur beim ersten Öffnen vom Backend laden
        if (nextState && !archiveLoaded) {
            try {
                const res = await axiosInstance.get("data/team?archived=true");

                setArchivedTeam(res.data);
                setArchiveLoaded(true);
            } catch (err) {
                console.error(err);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "data/team",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    return (
        <div className="team">
            <button className="add" onClick={() => setSelectedItem(true)}>Mitarbeiter hinzufügen</button>
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Nachname und Vorname</th>
                            <th>Kategorie</th>
                            <th>Fahrer</th>
                            <th className="options"></th>
                        </tr>
                    </thead>

                    <tbody>
                        {team.map((t) => (
                            <tr key={t.driver}>
                                <td>{t.driverAlias}</td>
                                <td>{t.categoryName}</td>
                                <td>
                                    {t.isDriver === 1 && (
                                        <CheckCircleOutlineRoundedIcon />
                                    )}
                                </td>

                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon
                                            onClick={() => setSelectedItem(t.driver)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="archive">
                <div className="topBar" onClick={toggleArchive}>
                    <div className="left">
                        {showArchive ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}
                        <span>Archivierte Mitarbeiter</span>
                    </div>

                </div>

                {showArchive && (
                    <div className="tableWrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Nachname und Vorname</th>
                                    <th>Kategorie</th>
                                    <th>Fahrer</th>
                                    <th>Deaktiviert am</th>
                                    <th className="options"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {archivedTeam.map((t) => (
                                    <tr key={t.driver}>
                                        <td>{t.driverAlias}</td>
                                        <td>{t.categoryName}</td>
                                        <td>
                                            {t.isDriver === 1 && (
                                                <CheckCircleOutlineRoundedIcon />
                                            )}
                                        </td>
                                        <td>
                                            {t.revokedAt
                                                ? moment(t.revokedAt).format("DD.MM.YYYY")
                                                : ""}
                                        </td>
                                        <td className="options">
                                            <div className="controls">
                                                <EditOutlinedIcon
                                                    onClick={() => setSelectedItem(t.driver)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {selectedItem && (
                <EditModal
                    title="Team"
                    isLoading={isLoading}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <ManageAccountsIcon />
                        <input
                            type="text"
                            value={item.driverAlias}
                            placeholder="Nachname und Name"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    driverAlias: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <CategoryRoundedIcon />
                        <select
                            type="text"
                            value={item.category}
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    category: e.target.value
                                }))
                            }
                        >
                            {categories.map((c) => (
                                <option value={c.id} key={c.id}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="group" onClick={() =>
                        setItem(prev => ({
                            ...prev,
                            isDriver: !prev.isDriver
                        }))
                    }>
                        <LocalShippingRoundedIcon />
                        <div className="checkbox">
                            <div className="box">
                                <div className={item.isDriver ? "check on" : "check"} />
                            </div>
                            <span>Fahrer</span>
                        </div>
                    </div>
                    <div className="group">
                        <PersonOffRoundedIcon />
                        <input
                            type="date"
                            value={item.revokedAt ? moment(item.revokedAt).format("YYYY-MM-DD") : ""}
                            placeholder="Deaktiviert am"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    revokedAt: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                        </div>
                    </div>
                </EditModal>
            )}
        </div>
    );
};

export default Team;